import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    codeAvis: null
};

export const codeAvisSlice = createSlice({
    name: 'codeAvis',
    initialState: initialState,
    reducers: {
        setCodeAvis: (state, action) => {
            state.codeAvis = action.payload;
        },
        reset: () => {
            return initialState;
        }
    }
});

export const { setCodeAvis, reset } = codeAvisSlice.actions;

export default codeAvisSlice.reducer;
